export function nextPage(page) {
  return {
    type: '@NAVIGATION_PAGE_NEXT_PAGE',
    payload: page
  };
}
